import React from 'react';
import contentDetails from 'core/data/content-details.json';
import UpComingProduct from './upcoming-product-file';
import PropertyGallery from 'components/artectum/item-detail/PropertyGallery';

const PortfolioDetails = () => {
    let publicUrl = process.env.PUBLIC_URL + '';
    const { sectionSubtitle, sectionTitle, content } = contentDetails;

    return (
        <div className="ltn__page-details-area ltn__portfolio-details-area mb-0 mt-5">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title-area ltn__section-title-2--- text-center mb-0">
                            <h6 className="section-subtitle ltn__secondary-color">
                                {sectionSubtitle}
                            </h6>
                            <h1 className="section-title mb-0">{sectionTitle}</h1>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="ltn__page-details-inner ltn__portfolio-details-inner">
                            {content.map((item, index) => (
                                <div key={index}>
                                    {item.text && <p>{item.text}</p>}
                                    {item.comments && (
                                        <div className="row">
                                            {item.comments.map((comment, commentIndex) => (
                                                <div className="col-lg-6" key={commentIndex}>
                                                    <div className="ltn__testimonial-item ltn__testimonial-item-3">
                                                        <div className="ltn__testimonial-img">
                                                            <img src={publicUrl + comment.image} alt="Contenido" />
                                                        </div>
                                                        <div className="ltn__testimoni-info">
                                                            <p>{comment.testimonial.text}</p>
                                                            <div className="ltn__testimoni-info-inner">
                                                                <div className="ltn__testimoni-img">
                                                                    <img src={publicUrl + comment.testimonial.authorImage} alt="Contenido" />
                                                                </div>
                                                                <div className="ltn__testimoni-name-designation">
                                                                    <h4>{comment.testimonial.authorName}</h4>
                                                                    <h6>{comment.testimonial.authorDesignation}</h6>
                                                                </div>
                                                            </div>
                                                            <div className="ltn__testimoni-bg-icon">
                                                                <i className="far fa-comments" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}
                            <UpComingProduct />
                            <div className="r mb-0 flex-column w-100 d-flex align-items-center">
                                <h2 className="mb-2">{sectionTitle}</h2>
                                <PropertyGallery publicUrl={publicUrl} mediaItems={contentDetails.mediaItems} title={false} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PortfolioDetails;